export default __webpack_public_path__ + "static/04-2fbd2fff0e3ef965e0f12dde719afaf3.jpg";